import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
  padded?: boolean;
}

export function Card({
  title,
  subtitle,
  icon,
  children,
  padded = true,
  className = '',
  ...rest
}: CardProps) {
  return (
    <section
      className={`bg-surface border border-line rounded-card shadow-[0_1px_2px_rgba(15,23,42,0.04)] ${
        padded ? 'p-4 sm:p-6' : ''
      } ${className}`}
      {...rest}
    >
      {(title || subtitle) && (
        <header className="mb-4">
          <h2 className="flex items-center gap-2 text-[17px] font-semibold text-ink leading-tight">
            {icon && <span className="text-ink-muted">{icon}</span>}
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-ink-muted leading-snug">{subtitle}</p>
          )}
        </header>
      )}
      {children}
    </section>
  );
}
